import App from "../../../../app/App";
import Layout from "../../../../views/Layout/Layout";

const Emails = {


    init() {

        this.el = $('[component="Emails"]');

        if (!this.el.length) {
            return;
        }

        this.dialog = this.el.find('[component="Dialog"]');
        this.button = {
            send: this.el.find('.dialog')
        }

        this.start();
        this.bind();
    },

    start() {

    },

    bind() {
        this.button.send.click((element) => {

            if ($(element.currentTarget).is(".disabled")) {
                return;
            }

            let button = Emails.getButtonAjaxProps(element.currentTarget);

            if (button.dialog) {
                Layout.setModalHeader(this.dialog, button.dialog);
            }

            Layout.setModalSubmitData(this.dialog, button);
            Layout.showModal(this.dialog);

            return false;
        });

        this.dialog.find(".confirm").click((element) => {

            let button = Emails.getButtonAjaxProps(element.currentTarget);
            let cronJob = App.getCronJobLink(button.job, button.test);

            if (!cronJob) {
                console.error("Missing cron link");
                return;
            }

            App.showLoading();
            App.ajax(
                button.library,
                button.event,
                {
                    link: CRON_ADRESS_SECURED,
                    request: cronJob
                }
            );

            Layout.hideModal(this.dialog);

            return false;
        });

        this.dialog.find(".cancel").click(() => {
            Layout.hideModal(this.dialog);
        })
    },

    getButtonAjaxProps(button) {
        return $(button).data();
    }
}
export default Emails;